import styled from '@emotion/styled'
import { Box, Checkbox, Link, TableContainer } from '@mui/material'
import { colors } from '@resiliatech/birdsong'

export const TasksContainer = styled(Box)`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  height: 100%;
  gap: 10px;
`

export const ContentContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const Task = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 10px;
`

export const TaskTableContainer = styled(TableContainer)`
  max-height: 400px;
  overflow: auto;
`

export const TaskStatusCheckbox = styled(Checkbox)`
  height: 24px;
  padding: 16px;
  width: 24px;
`

export const TaskTitleContainer = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const ActionsContainer = styled(Box)`
  align-items: center;
  color: ${colors.interactive.primaryEnabled};
  cursor: pointer;
  display: flex;
  gap: 16px;
`

export const TaskContentContainer = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const TaskTitle = styled(Link)`
  display: block;
  margin-bottom: 4px;
`

export const ResourceInfo = styled(Box)`
  margin-left: 8px;
`

export const TaskTitleRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`
